import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import { useForm, FormProvider } from 'react-hook-form';
import { CustomSingleSelect } from '@mgm/common/components/base';
import { TCreateEditForm } from '../../form';

const CustomEditSingleSelect = (props: GridRenderEditCellParams) => {
  const {
    id, value, field, options,
  } = props;

  const apiRef = useGridApiContext();

  const methods = useForm<TCreateEditForm>({
    mode: 'all',
  });

  const handleChange = (value: any) => {
    apiRef.current?.setEditCellValue({
      id,
      field,
      value,
    });
  };

  return (
    <FormProvider {...methods}>
      <CustomSingleSelect
        value={value}
        name="single"
        isRequired
        options={options}
        size="medium"
        sx={{
          borderRadius: 0,
        }}
        onChange={handleChange}
      />
    </FormProvider>
  );
};

export {
  CustomEditSingleSelect,
};
